module.exports = __webpack_public_path__ + "static/media/fenster_auf_active.f2f847e1.jpg";